import Dexie from "dexie";

const Database = new Dexie("Database");
Database.version(1).stores({
  receipts: "id",
  users: "id",
  loyaltycards: "id",
  bankingcards: "id",
});


export const  AddImportedReceiptsToDB = async (receiptData , setMassage  , addNewItemID ,setReceiptes,setHighlightedReceipts ) => {
  try {
    const existingReceipt = await Database.receipts.get(receiptData.id);

    if (!existingReceipt) {
      // Set the "created_at" key path when adding a new record
      receiptData.created_at = new Date().toISOString();
      
      await Database.transaction('rw', Database.receipts, async () => {
        await Database.receipts.put(receiptData);
      });
      // Adding the id of the receipts in the localDB to highlight it 
      addNewItemID(receiptData?.id  , setHighlightedReceipts);
      setReceiptes((prevReceiptes) => {
        if (prevReceiptes === null) {
          return [receiptData];
        } else {
          return [receiptData, ...prevReceiptes];
        }
      });
      setMassage('new')
    } else {
      // Set the "created_at" key path when updating an existing record
      receiptData.created_at = existingReceipt.created_at;

      await Database.receipts.update(receiptData.id, receiptData);
    }
  } catch (error) {
    console.error('Error handling receipts in the database:', error);
  }
};

